import api from '@/axios';
import type { ProductionDeclaration } from '@/types/core/purchase-order/production-declaration';

export async function getProductionDeclaration(
  productionDeclarationId: string,
  options?: { token?: string },
): Promise<ProductionDeclaration> {
  const response = await api.get<ProductionDeclaration>(
    `/production-declarations/${productionDeclarationId}`,
    {
      params: options?.token ? { token: options.token } : undefined,
    },
  );

  return response.data;
}
